import { useEffect, useRef, useState } from 'react'
import './styles.sass'

export default function NameSlugPlaceholder ({ name }) {
  const nameSlugRef = useRef()
  // eslint-disable-next-line
  const [slug, setSlug] = useState(generateNameSlug(name))

  function generateNameSlug (name) {
    let slug = ''
    if (!name) return slug
    const splittedName = name.split(' ')
    if (splittedName.length <= 2) {
      splittedName.forEach((splittedNameWord) => {
        slug = `${slug}${splittedNameWord.charAt(0)}`
      })
    } else if (splittedName.length > 2) {
      slug = `${splittedName[0].charAt(0)}${splittedName[1].charAt(0)}`
    }
    return slug ? slug.toUpperCase() : ''
  }

  function generateNameSlugColor (slug) {
    // Coolors palette: https://coolors.co/f94144-f3722c-f8961e-f9844a-f9c74f-90be6d-43aa8b-4d908e-577590-277da1
     
    const colors = [
      '#f94144',
      '#f3722c',
      '#f8961e',
      '#f9844a',
      '#f9c74f',
      '#90be6d',
      '#43aa8b',
      '#4d908e',
      '#577590',
      '#277da1',
    ]

    const sumValue = slug?.split('')?.length > 0 && slug.split('')?.reduce((a, b) => typeof a === 'string' ? a.charCodeAt(0) + b.charCodeAt(0) : 0)
    const index = sumValue % colors.length
    return colors[index]
  }

  useEffect(() => {
    nameSlugRef.current.style.backgroundColor = generateNameSlugColor(slug)
  }, [])
  
  return (
    <div className="-name-slug" ref={nameSlugRef}>
      {slug}
    </div>
  )
}
